<div>
  <h2 mat-dialog-title>{{ 'LIB_ORDERS.SALES_ORDERS.UPDATE_SALESPERSON' | translate }}</h2>
  <mat-dialog-content>
    @if (salespersonOptions$ | async; as salespersonOptions) {
      <EXP__glxy-wrap>
        <glxy-form-field prefixIcon="search" [showLabel]="true" matAutocompleteOrigin #origin="matAutocompleteOrigin">
          <glxy-label>{{ 'LIB_ORDERS.SALES_ORDERS.SELECT_SALESPERSON' | translate }}</glxy-label>
          <input
            type="input"
            matInput
            [matAutocomplete]="autocomplete"
            [matAutocompleteConnectedTo]="origin"
            [formControl]="searchCtrl"
          />
          @if (loading) {
            <glxy-loading-spinner
              matSuffix
              [size]="'default'"
              [fullWidth]="false"
              [fullHeight]="false"
              [inline]="true"
            ></glxy-loading-spinner>
          }
          @if (selectedSalesperson) {
            <button matSuffix mat-icon-button aria-label="Clear" (click)="unselectSalesperson()">
              <mat-icon>close</mat-icon>
            </button>
          }
        </glxy-form-field>
        <mat-autocomplete #autocomplete (optionSelected)="selectSalesperson($event)">
          @for (user of salespersonOptions; track user) {
            <mat-option [value]="user">
              <div>{{ user?.firstName }} {{ user?.lastName }}</div>
            </mat-option>
          }
          <glxy-infinite-scroll-trigger
            [visiblilityMargin]="120"
            (isVisible)="loadMore()"
          ></glxy-infinite-scroll-trigger>
        </mat-autocomplete>
      </EXP__glxy-wrap>
    }
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-stroked-button matDialogClose tabindex="-1">
      {{ 'FRONTEND.SALES_UI.CANCEL' | translate }}
    </button>
    <button mat-flat-button color="primary" (click)="select()">
      {{ 'FRONTEND.SALES_UI.SELECT' | translate }}
    </button>
  </mat-dialog-actions>
</div>
